import { getSessionSnapshot } from '../_lib/browserSession';

export function getData() {
    return getSessionSnapshot().user || {};
}
